import {
  FruitPropsType,
  dateType,
  FruitStatusType,
  isLockedType,
} from 'src/views/harvesting/fruit-profile/model';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { mergedFruit } from 'src/views/harvesting/fruit-profile/fruit-profile-single/utils/document-version-reader';

export const isFruitTextedByYouToday = (
  fruit: FruitPropsType,
  name: string
) => {
  return (
    fruit.fishermans &&
    fruit.fishermans[0] &&
    fruit.fishermans[0].name === name &&
    isFruitTextedToday(fruit)
  );
};

export const FRUIT_LOCK_EXPIRE_MINUTES = +(
  process.env.REACT_APP_FRUIT_LOCK_EXPIRE_MINUTE ?? 10
);
export const FRUIT_LOCK_FILTER_DATE =
  process.env.REACT_APP_FRUIT_LOCK_FILTER_DATE ?? '2023-05-29';

export const FRUIT_LOCK_FILTER_DATE_UNIX = moment(
  new Date(FRUIT_LOCK_FILTER_DATE)
).unix();

export const isFruitLockedByYouWithInExpireTime = (
  checkedFruit: FruitPropsType | false,
  name: string
) => {
  if (!checkedFruit) {
    return false;
  }
  return (
    !!checkedFruit.isLocked &&
    !!checkedFruit.isLocked.find(
      (lock) =>
        lock.name === name &&
        isBetweenMinutesFromNow(lock.createdAt, FRUIT_LOCK_EXPIRE_MINUTES)
    )
  );
};

export const isFruitTextedToday = (fruit: FruitPropsType) => {
  return (
    fruit.fishermans &&
    fruit.fishermans[0] &&
    isBetweenToday(fruit.fishermans[0].createdAt)
  );
};

export const isBetweenToday = (dateType: dateType) => {
  const compareDate = moment(dateType.seconds * 1000);
  const startDate = moment().startOf('day');
  const endDate = moment().endOf('day');

  return compareDate.diff(endDate) < 0 && compareDate.diff(startDate) >= 0;
};

export const isBetweenMinutesFromNow = (
  dateType: dateType,
  minutes: number
) => {
  const now = moment();
  const endDate = moment(dateType.seconds * 1000).add(minutes, 'minutes');

  return now.diff(endDate) < 0;
};

export const isFruitBlacklisted = (fruit: FruitPropsType) => {
  return fruit.isBlacklist;
};

export const isFruitAPastor = (fruit: FruitPropsType) => {
  return fruit.isPastor;
};
export const isFruitAFamilyMember = (fruit: FruitPropsType) => {
  return fruit.isFamilyMember;
};

export const fruitFishedBeforeFilterDate = (mergedFruit: FruitPropsType) => {
  if (mergedFruit.fishermans && mergedFruit.fishermans.length !== 0) {
    const lastestFishermanDate = mergedFruit.fishermans[0].createdAt;

    return moment(mergedFruit.fishermans[0].createdAt.seconds * 1000).isBefore(
      FRUIT_LOCK_FILTER_DATE
    );
  } else {
    return false;
  }
};

export const compare2FruitsTheSame = (
  newFruit: FruitPropsType,
  oldFruit: FruitPropsType
) => {
  //CHECK NEW FRUIT HAS facebookUsername THAT ALREADY EXISTS
  if (
    newFruit.hasOwnProperty('facebookUsername') &&
    oldFruit.hasOwnProperty('facebookUsername')
  ) {
    return newFruit.facebookUsername === oldFruit.facebookUsername;
  }
  //CHECK NEW FRUIT HAS facebookUserId THAT ALREADY EXISTS
  else if (
    newFruit.hasOwnProperty('facebookUserId') &&
    oldFruit.hasOwnProperty('facebookUserId')
  ) {
    return newFruit.facebookUserId === oldFruit.facebookUserId;
  }
  //CHECK NEW FRUIT HAS instagramId THAT ALREADY EXISTS
  else if (
    newFruit.hasOwnProperty('instagramId') &&
    oldFruit.hasOwnProperty('instagramId')
  ) {
    return newFruit.instagramId === oldFruit.instagramId;
  }

  //CHECK NEW FRUIT HAS name THAT ALREADY EXISTS
  else if (newFruit.hasOwnProperty('name') && oldFruit.hasOwnProperty('name')) {
    if (oldFruit.name?.trim().toLowerCase() === 'sara yékuno') {
      console.log('Sara Yékuno', newFruit, oldFruit);
    }
    // console.log(newFruit.name,newFruit,oldFruit);
    return (
      newFruit.name?.toLowerCase().trim() ===
      oldFruit.name?.toLowerCase().trim()
    );
  } else {
    return false;
  }
};

export const smartFilteringStatus = (
  targetFruit: FruitPropsType,
  checkedFruit: FruitPropsType,
  name: string
): FruitStatusType => {
  const mergedFruitInstant = mergedFruit(targetFruit, checkedFruit);

  if (isFruitTextedByYouToday(mergedFruitInstant, name)) {
    //TEXTED FRUIT
    return 'Texted';
  } else if (isFruitBlacklisted(mergedFruitInstant)) {
    //BLACKLIST FRUIT
    return 'Blacklisted';
  } else if (
    isFruitAPastor(mergedFruitInstant) ||
    isFruitAFamilyMember(mergedFruitInstant)
  ) {
    return 'Filtered';
  } else if (
    !mergedFruitInstant.fishermans ||
    mergedFruitInstant.fishermans.length === 0
  ) {
    return 'Available';
  } else if (fruitFishedBeforeFilterDate(mergedFruitInstant)) {
    return 'Available';
  } else if (compare2FruitsTheSame(targetFruit, checkedFruit)) {
    return 'Filtered';
  } else {
    return 'Available';
  }
};

// members
// pastors

export const smartListMerging = (
  fruits: FruitPropsType[],
  newFruits: FruitPropsType[]
) => {
  let uniqueNewFruits = [] as FruitPropsType[];

  newFruits.forEach((newfruit) => {
    const existingFruit = fruits.find((oldFruit) => {
      return compare2FruitsTheSame(newfruit, oldFruit);
    });
    if (!existingFruit) {
      const id = uuid();
      delete newfruit.pasteFormat;
      uniqueNewFruits = [
        ...uniqueNewFruits,
        { ...newfruit, id, status: 'Available', pending: true, version: 3 },
      ];
    }
  });
  return {
    newFruitsList: [...uniqueNewFruits, ...fruits].filter((x) => x.name),
    uniqueNewFruits,
  };
};

export const nameHasSpeicalCharacters = (text: string) => {
  const regex = /(https?:\/\/[^\s]+|\(|\))/g;
  return text.match(regex);
};

export const fruitHasValidateLockFromOthers = (
  fruit: FruitPropsType,
  name: string
) => {
  return filterAwayExpiredLocks(fruit.isLocked ?? []).filter(
    (lock) => lock.name !== name
  );
};

export const filterAwayExpiredLocks = (locks: isLockedType[]) => {
  return locks.filter((lock) =>
    isBetweenMinutesFromNow(lock.createdAt, FRUIT_LOCK_EXPIRE_MINUTES)
  );
};

export const removeMylocks = (locks: isLockedType[], name: string) => {
  return locks.filter((lock) => lock.name !== name);
};
